import { Component, OnInit } from '@angular/core';
import {PlatformService} from "../../services/PlatformService";

@Component({
  selector: 'app-install-notification',
  templateUrl: './install-notification.component.html',
  styleUrls: ['./install-notification.component.css'],
})
export class InstallNotificationComponent implements OnInit {
  showNotification = false;
  isAndroid = false;
  isIOS = false;

  constructor(private platformService: PlatformService) {}

  ngOnInit(): void {
    const hasSeenNotification = this.getCookie('install-notification');
    if (!hasSeenNotification) {
      this.showNotification = true;
      this.isAndroid = this.platformService.isAndroid();
      this.isIOS = this.platformService.isIOS();
    }
  }

  closeNotification(): void {
    this.showNotification = false;
    this.setCookie('install-notification', 'true', 365);
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/;`;
  }
}
